import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";

function FormEditarListaEspera({
    visible,
    onHide,
    observaciones,
    setObservaciones,
    metrajeRequerido,
    setMetrajeRequerido,
    loading,
    onSave
}) {
    return (
        <Dialog
            header="Editar Solicitud de Lista de Espera"
            visible={visible}
            onHide={onHide}
            className="p-fluid product-dialog"
            modal
            footer={
                <div className="flex justify-content-end">
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button mr-2 p-button-rounded p-button-outlined"
                        onClick={onHide}
                    />
                    <Button
                        label="Guardar"
                        icon={loading ? "pi pi-spinner" : "pi pi-save"}
                        className="p-button-success p-button-rounded p-button"
                        raised
                        loading={loading}
                        onClick={onSave}
                    />
                </div>
            }
        >
            <div className="grid">
                <div className="col-12 md:col-6">
                    <label className="mb-1">Metraje Requerido</label>
                    <InputNumber
                        value={metrajeRequerido || ""}
                        onChange={(e) => setMetrajeRequerido(e.value)}
                        placeholder="ej: 1000"
                        min={0}
                        useGrouping={false}
                    />
                </div>
                <div className="col-12">
                    <label className="mb-1">Observaciones</label>
                    <InputTextarea
                        value={observaciones || ""}
                        onChange={(e) => setObservaciones(e.target.value)}
                        autoResize
                        rows={3}
                        placeholder="Notas de la solicitud"
                    />
                </div>
            </div>
        </Dialog>
    );
}

export default FormEditarListaEspera;